var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCockpit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cockpit"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.2274 9.34981V10.8903C16.4979 10.8903 16.7297 10.8519 17.0001 10.8519C17.2706 10.8519 17.5024 10.8519 17.7729 10.8903V9.34981C19.2797 9.42656 20.7092 9.73493 22.0228 10.2352L21.4433 11.6222C21.9456 11.8147 22.4092 12.0073 22.8728 12.2382L23.4524 10.8136C24.1864 11.1596 24.8433 11.5838 25.5001 12.0457L27.1614 10.3894C24.341 8.27119 20.8251 7 17.0001 7C7.61159 7 0.000244141 14.5881 0.000244141 23.9482V25.4887H2.31841V23.9482C2.31841 22.3687 2.58889 20.8282 3.05252 19.4028L4.48205 19.9805C4.63657 19.4795 4.82979 19.0177 5.02295 18.5551L3.59342 17.9774C4.17294 16.6679 4.98432 15.4358 5.91158 14.3955L6.99337 15.4741C7.34111 15.089 7.68885 14.7039 8.07522 14.3571L6.99337 13.2785C8.03659 12.3157 9.23427 11.468 10.5479 10.8136L11.1274 12.2382C11.5911 12.0073 12.0547 11.8147 12.557 11.6222L11.9774 10.1968C13.2911 9.69656 14.7206 9.42656 16.2274 9.34981Z",
    fill: "#FFC000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M30.9477 14.2413L29.2864 15.8976C29.7113 16.5527 30.0977 17.2455 30.4068 17.939L28.9773 18.5551C29.1704 19.0176 29.3637 19.5186 29.5182 19.9805L30.9477 19.4028C31.4113 20.8281 31.6818 22.3686 31.6818 23.9482V25.4887H34V23.9482C34 20.3272 32.8795 17.0146 30.9477 14.2413Z",
    fill: "#FFC000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.9184 23.2547C15.8412 23.2931 15.8025 23.3705 15.7252 23.4472C15.1843 24.1017 15.2616 25.0652 15.9184 25.6429C16.5752 26.1822 17.5411 26.1047 18.1206 25.4503L30.1365 11.237L15.9184 23.2547Z",
    fill: "#FFC000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCockpit);
export default __webpack_public_path__ + "static/media/Cockpit.d42dc8ac3fd0850c77020e8a7b8f465d.svg";
export { ForwardRef as ReactComponent };